import { Component, OnInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-hidden-wrapper',
  template: '',
})
export class FormlyHiddenWrapperComponent extends FieldWrapper implements OnInit {
  public ngOnInit(): void {
    this.field.className = 'd-none';
  }
}
